import { useState } from "react";
import buttoncss from "../css/button.module.css";
import commoncss from "../css/common.module.css";
import bookclosuretbcss from "../css/bookclosuretb.module.css";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import { ReactComponent as LeftIcon } from "../assets/icons/left_arrow.svg";
import { ReactComponent as SearchIcon } from "../assets/icons/search.svg";
import { ReactComponent as DeleteIcon } from "../assets/icons/delete_icon_primary.svg";
import Dropdown from "../elements/Dropdown";
import ToggleButton from "../elements/ToggleButton";
import {Button} from "../elements/Button";
import Table from "../elements/Table";
import temp_viewtb from "../data/temp_viewtb.json";
import PageWithSubTables from "../components/bookclosure/TempTables";

const BookClosureTB = () => {
  const [mode, setMode] = useState("TEMPLATE");

  const bookClosure = () => {
    window.location.href = "/myfinv2/book-closure";
  };

  const th_data = [
    { header: <input type="checkbox" value="" key="" />, accessor: "checkbox" },
    { header: "LEDGER NAME", accessor: "ledger_name" },
    { header: "PERIOD BEGINNING BALANCE", accessor: "period_begin_bal" },
    { header: "PERIOD ENDING BALANCE", accessor: "period_end_bal" },
    { header: "AMOUNT IN", accessor: "amount_in" },
  ];

  const tr_data = temp_viewtb.map((item, i) => ({
    checkbox: (
      <input type="checkbox" value={item.ledger_code} key={`checkbox-${i}`} />
    ),
    ledger_code: item.ledger_code,
    ledger_name: item.ledger_name,
    period_begin_bal: item.period_begin_bal,
    period_end_bal: item.period_end_bal,
    amount_in: item.amount_in,
  }));

  return (
    <div>
      <div className="bk-closure-tb-header">
        <div className="bk-closure-tb-header-left">
          <LeftIcon height={15} width={15} className="clickable" onClick={()=>{bookClosure()}} />
          <SearchIcon />
          <FilterIcon />
          <DeleteIcon />
          <span>
            <ToggleButton label="Split Mapping" />
          </span>
        </div>
        <div className="button-group ml-10">
          <button
            className={`${buttoncss.custom_btn} ${
              mode === "TEMPLATE" ? buttoncss.primary : buttoncss.secondary
            }`}
            style={{ "border-radius": "8.18px 0px 0px 8.18px" }}
            onClick={() => {
              setMode("TEMPLATE");
            }}
          >
            Template mode
          </button>
          <button
            className={`${buttoncss.custom_btn} ${
              mode === "CONVENTIONAL" ? buttoncss.primary : buttoncss.secondary
            }`}
            style={{
              "border-radius": "0 8.18px 8.18px 0",
            }}
            onClick={() => {
              setMode("CONVENTIONAL");
            }}
          >
            Conventional mode
          </button>
        </div>
        <div className="bk-closure-tb-header-right">
          <Button btnColor={buttoncss.secondary} label="Upload Trail Balance" />
          <Button btnColor={buttoncss.secondary} label="Save CoA" />
          <Button
            btnColor={buttoncss.primary}
            label="Confirm Grouping"
            onClick={bookClosure}
          />
        </div>
      </div>
      <div>
        {mode === "TEMPLATE" && (
          <div class={`${commoncss.pdlr15} ${bookclosuretbcss.tabContainer}`}>
            <div class={`${commoncss.pdlr15} ${bookclosuretbcss.templateDiv}`}>
              <Table columns={th_data} data={tr_data} />
            </div>
            <div
              class={`${commoncss.pdlr15} ${bookclosuretbcss.convectionalDiv}`}
            >
              <div className={`${bookclosuretbcss.tempNotesSection}`}>
                <Dropdown
                  class_={commoncss.w60pct}
                  options={[
                    {
                      label: "Notes",
                      value: "Notes",
                    },
                  ]}
                  onSelect={(value) => {}}
                  placeHolder={"Notes"}
                />
                <div className="button-group">
                  <button
                    className={`${buttoncss.custom_btn} ${
                      mode === "TEMPLATE"
                        ? buttoncss.primary
                        : buttoncss.secondary
                    }`}
                    style={{ "border-radius": "8.18px 0px 0px 8.18px" }}
                    onClick={() => {
                      setMode("TEMPLATE");
                    }}
                  >
                    BS
                  </button>
                  <button
                    className={`${buttoncss.custom_btn} ${
                      mode === "CONVENTIONAL"
                        ? buttoncss.primary
                        : buttoncss.secondary
                    }`}
                    style={{
                      "border-radius": "0 8.18px 8.18px 0",
                    }}
                    onClick={() => {
                      setMode("CONVENTIONAL");
                    }}
                  >
                    P&L
                  </button>
                </div>
              </div>
              <div>
                <PageWithSubTables />
              </div>
            </div>
          </div>
        )}
        {mode === "CONVENTIONAL" && (
          <div className={commoncss.pdlr15}>
            <Table columns={th_data} data={tr_data} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BookClosureTB;
